export default __webpack_public_path__ + "static/media/blumeattempt-justlikeyou-cover.cf7a90e3.jpg";